module.exports = __webpack_public_path__ + "static/record-3-a40c88f0a7e34c45a925838120f4408e.jpg";